module.exports = __webpack_public_path__ + "static/fee08-7a699cbd53235b47e8b2e66c45a3b902.png";